import { Form, InputGroup, Alert } from "react-bootstrap";
import SubmitBtn from "../../../common/submitBtn";
import { Formik } from "formik";
import { object, string } from "yup";
import { AiOutlineUser } from "react-icons/ai";
import { GrShieldSecurity } from "react-icons/gr";
import { AiOutlineExclamationCircle } from "react-icons/ai";

const ChangeUserPermissionsForm = (props) => {
  const validationSchema = object().shape({
    username: string().required("Username is required"),
    permission: string().required("Select a permission"),
  });

  const handleValidatations = (values) => {
    const errors = {};
    if (values.permission === "Select") {
      errors.permission = "Select a permission";
    }
    return errors;
  };

  return (
    <section>
      <Formik
        initialValues={{ username: "", permission: "" }}
        validationSchema={validationSchema}
        validate={(values) => handleValidatations(values)}
        onSubmit={(values, actions) =>
          props.handleFormikSubmit(values, actions)
        }
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleSubmit,
          isSubmitting,
        }) => (
          <Form className="mt-3" onSubmit={handleSubmit}>
            {/* {console.log("Values:", values)} */}
            <Form.Group className="mb-3 text-start" controlId="password">
              <Form.Label>SembraSchool User</Form.Label>
              <InputGroup>
                <InputGroup.Text>
                  <AiOutlineUser />
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  placeholder="Agency Code + Employee IVRID (ex: hch100137)"
                  name="username"
                  onChange={(e) => {
                    handleChange(e);
                    props.handleUserMessage(null);
                  }}
                  value={values.username}
                  className={
                    errors.username && touched.username ? "input-error" : null
                  }
                />
                {errors.username && touched.username && (
                  <InputGroup.Text
                    className={errors.username ? "error-icon" : null}
                  >
                    <AiOutlineExclamationCircle />
                  </InputGroup.Text>
                )}
              </InputGroup>
              {errors.username && touched.username ? (
                <Alert variant="danger">{errors.username}</Alert>
              ) : null}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Permissions</Form.Label>
              <InputGroup>
                <InputGroup.Text>
                  <GrShieldSecurity />
                </InputGroup.Text>
                <Form.Select
                  aria-label="Permissions"
                  name="permission"
                  onChange={(e) => {
                    handleChange(e);
                    props.handleUserMessage(null);
                  }}
                  className={
                    errors.permission && touched.permission
                      ? "input-error"
                      : null
                  }
                >
                  <option>Select</option>
                  <option value="Caregiver">Caregiver</option>
                  <option value="Admin">Admin</option>
                  <option value="Owner">Owner</option>
                </Form.Select>
                {errors.permission && touched.permission && (
                  <InputGroup.Text
                    className={errors.permission ? "error-icon" : null}
                  >
                    <AiOutlineExclamationCircle />
                  </InputGroup.Text>
                )}
              </InputGroup>
              {errors.permission && touched.permission ? (
                <Alert variant="danger">{errors.permission}</Alert>
              ) : null}
            </Form.Group>
            
            <SubmitBtn isSubmitting={isSubmitting} text={"Update Permission"} />
          </Form>
        )}
      </Formik>
    </section>
  );
};

export default ChangeUserPermissionsForm;
